// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-module--content--2CPz1","wide":"layout-module--wide--1rsAP","cards":"layout-module--cards--Z-Qx4","decoration":"layout-module--decoration--2dc9q"};